export const accent = 'white';
